export enum BacktestingStatus {
  RUNNING = 'Running',
  PAUSED = 'Paused'
}

export interface ControlState {
  date: string;
  time: string;
  status: BacktestingStatus;
}